import NotFoundFeature from '../features/system/not-found-feature';

export default function NotFoundPage() {
  return <NotFoundFeature />;
}
